// @ts-nocheck
import { getDraftPolicy } from 'views/App/Portal/Policy/DraftManuals/_data_sources/useDraftPolicy';
import useManagePolicy from 'views/App/Portal/Policy/DraftManuals/_data_sources/useManagePolicy';
import ContentConversionHelper from 'views/App/Portal/Policy/DraftManuals/helpers/contentConversionHelper';
import { DraftPolicySection } from 'views/App/Portal/Policy/_types/manuals/draft';
import sampleContent from 'views/App/Portal/Policy/_helpers/sampleContent.json';

declare global {
  interface Window {
    setSampleLists: (manualId: string, policyId: string) => Promise<void>;
  }
}

window.setSampleLists = async (manualId: string, policyId: string) => {
  console.log('Starting setSampleLists...');
  
  try {
    // Get the policy data
    console.log('Fetching policy data...');
    const policyData = await getDraftPolicy(manualId, policyId);
    console.log('Policy data fetched:', policyData);

    // Create a map of existing sections by title for easy lookup
    const existingSectionsMap = new Map(
      policyData.sections.map(section => [section.title, section])
    );
    
    // Create new sections array
    const newSections: DraftPolicySection[] = [];
    
    // Loop through sample content lists
    console.log('Processing sample content lists...');
    for (const [key, value] of Object.entries(sampleContent.lists)) {
      console.log(`Processing list: ${key}`);
      
      const title = key
        .split('-')
        .map(word => {
          if (word === 'ol') return 'Ordered List';
          if (word === 'ul') return 'Unordered List';
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');

      // Check if section already exists
      const existingSection = existingSectionsMap.get(title);
      
      if (existingSection) {
        // Update existing section
        const updatedSection: DraftPolicySection = {
          ...existingSection,
          content: key.includes('phx-') ? ContentConversionHelper.contentForRender(value) : value,
          contentEditable: value,
        };
        newSections.push(updatedSection);
      } else {
        // Create new section
        const newSection: DraftPolicySection = {
          attachments: [],
          agencyModified: false,
          content: key.includes('phx-') ? ContentConversionHelper.contentForRender(value) : value,
          contentEditable: value,
          id: '',
          isNew: false,
          editLevelTag: 'AGENCY_CONTENT',
          state: 'ENABLED',
          subSections: [],
          title,
          parentId: null
        };
        newSections.push(newSection);
      }
    }
    console.log('New sections:', newSections);

    // Create deep copy of policy data
    console.log('Creating deep copy of policy data...');
    const updatedPolicy = JSON.parse(JSON.stringify(policyData));
    updatedPolicy.sections = newSections;

    // Get manage policy functions
    const { getLock, update, removeLock } = useManagePolicy();

    // Get lock
    console.log('Getting lock...');
    await getLock(manualId, policyId);

    // Update policy
    console.log('Updating policy...');
    await update(manualId, policyId, updatedPolicy);

    // Remove lock
    console.log('Removing lock...');
    await removeLock(manualId, policyId);

    console.log('setSampleLists completed successfully!');
  } catch (error) {
    console.error('Error in setSampleLists:', error);
  }
}; 